import { render, staticRenderFns } from "./NaoVenda.vue?vue&type=template&id=fd964186"
import script from "./NaoVenda.vue?vue&type=script&lang=js"
export * from "./NaoVenda.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports